import { Button, Result } from 'antd'
import { useRouter } from '@tanstack/react-router'

import { ROUTES } from '@/core/constants/routes'

type Props = {
  error: Error
  reset?: () => void
}

/**
 * Rota başına hata fallback'i. TanStack Router `errorComponent` ile mount edin;
 * bir rotanın render hatası tüm kabuğu (sidebar + header) boşaltmasın.
 */
const RouteError = ({ error, reset }: Props) => {
  const router = useRouter()
  console.error('[route-error]', error)

  const onRetry = () => {
    reset?.()
    router.invalidate()
  }

  return (
    <Result
      status="error"
      title="Bu sayfa yüklenemedi"
      subTitle={error.message || 'Beklenmeyen bir hata.'}
      extra={[
        <Button key="retry" type="primary" onClick={onRetry}>
          Yeniden Dene
        </Button>,
        <Button key="home" onClick={() => router.navigate({ to: ROUTES.app })}>
          Anasayfaya Dön
        </Button>,
      ]}
    />
  )
}

export default RouteError
